import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { useUserCustomGroupsBks } from 'src/hooks/use-user-custom-groups-bks';
import { AssignmentsWorkTypeMap } from 'src/interfaces/assignment.types';
import authService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { useGetTeacherAssignmentsQuery } from 'src/store/api/assignment';
import {
  useActiveMSAssignmentsSubject,
  useCurrentAppViewSelector,
  useHasViewUpdatedSelector,
  useSelectedClassSelector,
} from 'src/store/features';
import { getRelevantWorkTypeForQuery } from 'src/utils/assignments.utils';

export const useMSTeacherAssignmentsByWorkType = (
  workType: AssignmentsWorkTypeMap,
) => {
  const selectedClass = useSelectedClassSelector();
  const isMiddleSchoolView = useIsMiddleSchoolView();
  const currentAppView = useCurrentAppViewSelector();

  const activeMSAssignmentsSubject = useActiveMSAssignmentsSubject();

  const isStudent = authService.isStudent();

  const hasViewUpdated = useHasViewUpdatedSelector();

  const classBks = selectedClass?.length
    ? selectedClass.map((cl) => cl.sourcedId)
    : [];
  const groupBks = useUserCustomGroupsBks();

  const shouldSkipQuery =
    isStudent ||
    // now query is allowed for class-less users, so only check for undefined
    selectedClass === undefined ||
    groupBks === undefined ||
    currentAppView === null ||
    !isMiddleSchoolView ||
    !hasViewUpdated;

  // pass correct workType instead of skipping query for Apps section - for correct realtime logic work
  const relevantWorkType = getRelevantWorkTypeForQuery(workType);

  const queryResult = useGetTeacherAssignmentsQuery(
    {
      classBks,
      groupBks,
      includeSingleSessionCodes: true,
      domain: activeMSAssignmentsSubject,
      workType: relevantWorkType,
    },
    { skip: shouldSkipQuery },
  );

  if (queryResult.error) {
    loggerService.logError(
      'Something went wrong during MS teacher assignments query',
      queryResult.error,
    );
  }

  return queryResult;
};
